import { CreateFocusCss } from '../../../../styles'
import type { Tokens } from '../../../../theming/types'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    wrap: {
      '& a, & button': {
        ...CreateFocusCss({
          ...tokens.focusOuter,
          outlineColor: '#2463d1',
        }),
      },
    },
  } as const
}
